


















import {Component, Prop, Vue} from 'vue-property-decorator';
import firebase from "firebase";
import FirebaseConnectionStore from "@/store/modules/FirebaseConnection/FirebaseConnectionStore";

@Component({})

export default class Message extends Vue {

    private text: string = "";
    private date: Date = new Date;

    private unWatchRealtimeUpdate: Function = new Function();

    get yymmdd() {
        return (
            this.date.getFullYear() + "/"
            + (this.date.getMonth() + 1) + "/"
            + this.date.getDate()
            + "  " +
            this.date.getHours() + ":"
            + this.date.getMinutes()
        );
    }

    mounted() {
        if (FirebaseConnectionStore.isConnected) {
            this.getMessage();
            return;
        }

        this.unWatchRealtimeUpdate = this.$watch(
            () => FirebaseConnectionStore.isConnected,
            () => this.getMessage()
        )
    }

    private getMessage() {
        this.unWatchRealtimeUpdate = firebase.firestore()
            .collection("messages")
            .onSnapshot(
                snapshot => {
                    const data = snapshot.docs[0].data();
                    this.text = data.text;
                    this.date = new Date(data.date.seconds * 1000);
                },
                error => {
                    console.log("message snapshot error ", error);
                }
            );
    }

    destroyed(): void {
        this.unWatchRealtimeUpdate();
    }
}
